// extracted by mini-css-extract-plugin
export default {"wrapper":"eU-z","ratingContainer":"fU-z","ratingValue":"gU-z","starSprite":"hU-z","ratingLabel":"iU-z","error":"jU-z","errorBox":"kU-z"};